module.exports = __webpack_public_path__ + "fonts/SalesforceSans-LightItalic.676a9c306dd2390c45ec0d0b28e51a6a.woff2";